import { logWarning } from '@databases/logs';

import { getConfluenceService } from '@canvas/atlassian-service/confluence';

export const fetchParentThreadIdFromCommentContentId = async (
  contentId: string,
  commentId: string
) => {
  try {
    const comment = await getConfluenceService().getCommentDetails({
      contentId,
      commentId,
    });

    if (comment == null) {
      throw new Error('Comment not found');
    }

    if (comment.location.type !== 'INLINE') {
      throw new Error('Comment is not an inline comment');
    }

    const threadId = comment.location.inlineMarkerRef;
    return threadId;
  } catch (error: unknown) {
    if (error instanceof Error) {
      logWarning('Error fetching comment', error);
    }
    return undefined;
  }
};
